/**
 * Kinek mennyire halkan halljuk - CSAK NALUNK.
 *
 * A hivasban nem mindenki egyforma hangos: az egyik fejhallgatoba beszel
 * kozelrol, a masik a szoba masik vegebol, egy harmadiknal szol a radio. Eddig
 * erre egyetlen valasz volt, a teljes elnemitas - ami viszont MINDENKINEL
 * elnemitja az illetot, mert a szerverre megy. Ez a modul a masik felet adja
 * hozza: a sajat fulunkre allitani valakit halkabbra.
 *
 * ─── Miert nem megy a szerverre? ────────────────────────────────────────────
 *
 * Mert nem is tartozik masra. Ha valakit halkabban hallgatok, az az en
 * dolgom - nem allapot, amirol a tobbieket ertesiteni kellene, es nem is
 * olyasmi, amit egy masik gepen ugyanugy akarnek. A LiveKit `setVolume`-ja
 * eleve lokalis: a hangot a sajat lejatszasunkban halkitja, a masik felhez es
 * a tobbiekhez nem jut el belole semmi.
 *
 * ─── Miert marad meg hivasok kozott? ────────────────────────────────────────
 *
 * Mert aki egyszer lehalkitott valakit, az legkozelebb is halkabban akarja
 * hallani - ugyanaz a mikrofon, ugyanaz a szoba. Ugyanaz a gondolat, mint az
 * eszkoz-emlekezetnel (lasd `devices.ts`).
 */

const STORAGE_KEY = 'avslack.huddle.volumes';

/** Amit taroljuk: felhasznalo-azonosito -> hangero (0-1). */
type Store = Record<string, number>;

/**
 * A HANGOSITAST is engedjuk, nem csak a halkitast.
 *
 * Aki halkan beszel egy rossz mikrofonba, azt fel kell tudni hozni - a
 * halkitas onmagaban csak a problema felere valasz. A ketszeres a bongeszok
 * altal meg torzitas nelkul kezelt savon belul van.
 */
export const MAX_VOLUME = 2;

function read(): Store {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};

    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};

    // Csak a szamokat engedjuk at: egy kezzel elirt vagy regi alaku bejegyzes
    // ne tudjon `NaN`-t vinni a `setVolume`-ba, amitol elnemulna valaki.
    const result: Store = {};
    for (const [userId, value] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof value === 'number' && Number.isFinite(value)) {
        result[userId] = clamp(value);
      }
    }
    return result;
  } catch {
    // Privat ablak, tiltott tarolo: a hivas ettol meg mukodjon.
    return {};
  }
}

function write(store: Store): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // Nem tudtuk eltenni - a beallitas erre a hivasra igy is ervenyes.
  }
}

export function clamp(volume: number): number {
  return Math.min(MAX_VOLUME, Math.max(0, volume));
}

/** Minden megjegyzett hangero. A hivo ebbol dolgozik, hogy ne olvassunk lemezt savonkent. */
export function loadVolumes(): Store {
  return read();
}

/**
 * Egy beallitas eltetele.
 *
 * Az alapertelmezest (1) TOROLJUK, nem taroljuk: enelkul a tarolo lassan
 * megtelne olyan bejegyzesekkel, amik semmit nem jelentenek - es evek mulva
 * sem lehetne megmondani, kit allitott be tudatosan a felhasznalo.
 */
export function rememberVolume(userId: string, volume: number): void {
  const store = read();

  if (volume === 1) delete store[userId];
  else store[userId] = clamp(volume);

  write(store);
}
